@if (control) {
  <!-- FE-2: the required marker sits on the text, not on the row, so it stays welded to the words
       when the info icon follows them. -->
  <div class="form-field-label">
    <span [class.required-label]="isFormControlRequired()">{{ label | transloco }}</span>
    @if (info) {
      <span
        class="info-icon ml-2 dashboard-tooltip"
        matTooltipClass="dig-tooltip"
        #infoTooltip="matTooltip"
        (click)="infoTooltip.toggle()"
        [matTooltip]="info | transloco"
      >
        <span inlineSVG="/icons/icon-info-circle-v2.svg"></span>
      </span>
    }
  </div>
  <mat-form-field
    class="form-field form-field-date lib-datepicker-container"
    [ngClass]="{ disabled }"
    [floatLabel]="'auto'"
  >
    <input matInput [matDatepicker]="picker" [formControl]="control" [required]="isFormControlRequired()" readonly />
    @if (!disabled) {
      <mat-datepicker-toggle class="btn-datepicker" matSuffix [for]="picker"></mat-datepicker-toggle>
    }
    @if (!disabled) {
      <span class="icon icon-remove" [inlineSVG]="'/icons/icon-close.svg'" (click)="control.setValue('')"></span>
    }
    <mat-datepicker #picker [disabled]="disabled" [startView]="startView"></mat-datepicker>
    @if (control.invalid) {
      <mat-error>
        @if (control.errors.required) {
          {{ 'form.error.required' | transloco }}
        }
        @if (control.errors.datesRange) {
          {{ 'form.error.dates_range' | transloco }}
        }
      </mat-error>
    }
  </mat-form-field>
}
